import { lazy } from "react";
import VideoThumbnail from "../../Video/Components/VideoThumbnail";

const ProductThumbnail = lazy(() =>
  import("../../Product/Components/ProductThumbnail")
);

export const ThumbnailSection = ({
  cardType,
  item,
  handleOpenSinglePublish,
}) => {
  const renderThumbnail = () => {
    switch (cardType) {
      case "Product":
        return <ProductThumbnail product={item} />;
      case "Video":
        return (
          <VideoThumbnail
            item={item}
            handleOpenSinglePublish={handleOpenSinglePublish}
          />
        );
      default:
        return null;
    }
  };

  return renderThumbnail();
};
